import { ConfidenceFunction, DynamicConsensusConfig } from '@scale/shared-types';
import { DynamicConsensusConfigSchema } from '@scale/shared/pipelinev3/contentUnderstanding/paramsSchema';
import React from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Button } from '@scale/scaleui';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface DynamicConsensusConfigsBuilderProps {
  name: string;
  existingValue?: Array<DynamicConsensusConfig>;
  updateProperty: (arg: Array<DynamicConsensusConfig> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const DynamicConsensusConfigsBuilder: React.FC<DynamicConsensusConfigsBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const configs = existingValue;

  const addConfig = () => {
    const newConfigs = [...configs];
    newConfigs.push({
      confidenceThreshold: 0.5,
      confidenceFunction: ConfidenceFunction.Agreement,
      maxAttempts: 5,
    });
    updateProperty(newConfigs);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-lg">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={configs}
        setElements={updateProperty}
        getKey={config => `${config.confidenceThreshold}-${config.confidenceFunction}`}
        getTitle={() => 'Config'}
        getSchema={_ => DynamicConsensusConfigSchema}
      />
      <Button onClick={() => addConfig()}>Add Dynamic Consensus Config</Button>
    </div>
  );
};

export default DynamicConsensusConfigsBuilder;
